// extracted by mini-css-extract-plugin
export default {"page":"Success_page__+Xa3C","text":"Success_text__r1dJ3","success":"Success_success__Q4gjZ"};